import { Endpoints, generateAxios } from '@matap/shared';
import { generateQuery, generateMutation, generateDataQueryHook } from './create-hooks';

export const useQueryDoctors = generateDataQueryHook(Endpoints.users.user.query, {
  queryKey: 'useQueryDoctors',
});

export const usePatchProfile = generateMutation(Endpoints.users.user.update, (endpoint) => ({
  mutationFn: (payload) => generateAxios(endpoint, payload).then((r) => r.data),
}));

export const useMe = generateQuery(Endpoints.users.user.me, (endpoint, payload) => ({
  queryKey: [],
  gcTime: 0,
  queryFn: () => generateAxios(endpoint, payload).then((r) => r.data),
}));
